import { cn } from '../../lib/cn';
import { StatusBar } from './StatusBar';
import type { DeviceFrame as DeviceFrameType, ThemeMode } from '../../types';

interface DeviceFrameProps {
  children: React.ReactNode;
  device?: DeviceFrameType;
  theme?: ThemeMode;
  className?: string;
}

export function DeviceFrame({
  children,
  device = 'android',
  theme = 'light',
  className,
}: DeviceFrameProps) {
  const isIPhone = device === 'iphone';

  return (
    <div
      className={cn(
        'relative mx-auto overflow-hidden rounded-[2.5rem] border-[8px] border-slate-900 bg-slate-950 shadow-elevation-4',
        isIPhone ? 'w-[375px] h-[812px]' : 'w-[360px] h-[760px]',
        className
      )}
    >
      {isIPhone && (
        <div className="absolute left-1/2 top-2 z-20 h-7 w-28 -translate-x-1/2 rounded-full bg-black" />
      )}
      <div className={cn('flex h-full w-full flex-col overflow-hidden', theme === 'dark' ? 'dark' : '')}>
        <StatusBar variant={device} />
        <div className="flex-1 overflow-hidden rounded-b-[2rem]">{children}</div>
      </div>
    </div>
  );
}
